import React from "react";
import ServicesList from "./ServicesList";
import ReportsList from "./ReportsList";
import { openPrint } from "../utils/print";
import { REPORT_TAB_LABELS } from "../constants/reportTabs";

const Sidebar = ({
  platforms,
  services,
  onSelect,
  activePlatforms,
  toggleAll,
  darkMode,
  userInfo,
  lastUpdateDate,
  activeView,
  setActiveView,
  activeReportTab,
  setActiveReportTab,
  reports,
}) => {
  const img = localStorage.getItem("image");
  const nameb = localStorage.getItem("name");

  // ── الطباعة: كل زرار بيقرا الـ HTML من الـ content بتاعه ويبعته لـ openPrint المشترك ──
  const printPlatformCards = () => {
    const content = document.querySelector(".platform-cards")?.innerHTML || "";
    openPrint(
      `تقرير متابعة أرقام ${userInfo?.name}`,
      `<div class="platform-content">${content}</div>`,
      nameb,
    );
  };

  const printReports = () => {
    const content = document.querySelector(".reports-content")?.innerHTML || "";
    const label = REPORT_TAB_LABELS[activeReportTab] || "التقارير";
    openPrint(
      `تقرير ${label}`,
      `<h3 style="text-align:center;margin-bottom:20px">تقرير ${label}</h3>
       <div class="reports-print-content">${content}</div>`,
      nameb,
    );
  };

  const printUpdates = () => {
    const content = document.querySelector(".updates-content")?.innerHTML || "";
    openPrint(
      `آخر التحديثات - ${nameb}`,
      `<h3 style="text-align:center;margin-bottom:20px">آخر التحديثات</h3><div>${content}</div>`,
      nameb,
    );
  };

  return (
    <div
      className={`${darkMode ? "dark container" : "light container"} sidebar`}
    >
      {/* ── User info ── */}
      <div className="sidebar-user">
        <div className="user-image">
          <img
            src={`http://backend.goldensection.agency/public/${img}`}
            alt={nameb}
          />
        </div>
        <span className="welcome-text">مرحباً</span>
        <h3>{nameb}</h3>
      </div>

      {/* ── Last update ── */}
      {activeView === "platforms" && lastUpdateDate && (
        <div className="last-update-box">
          <span className="last-update-icon">🕐</span>
          <div className="last-update-text">
            <span className="last-update-label">آخر تحديث للبيانات</span>
            <span className="last-update-val">
              {new Date(lastUpdateDate).toLocaleDateString("ar-EG", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </span>
          </div>
        </div>
      )}

      {activeView === "reports" && reports?.last_update?.date && (
        <div className="last-update-box">
          <span className="last-update-icon">🕐</span>
          <div className="last-update-text">
            <span className="last-update-label">آخر تحديث للتقارير</span>
            <span className="last-update-val">
              {new Date(reports.last_update.date).toLocaleDateString("ar-EG")}
            </span>
          </div>
        </div>
      )}

      {/* ── View switch ── */}
      <div className="view-switch">
        <button
          className={`view-switch-btn ${activeView === "platforms" ? "active" : ""}`}
          onClick={() => setActiveView("platforms")}
        >
          لوحة البيانات
        </button>
        <button
          className={`view-switch-btn ${activeView === "reports" ? "active" : ""}`}
          onClick={() => setActiveView("reports")}
        >
          التقارير
        </button>
        <button
          className={`view-switch-btn ${activeView === "updates" ? "active" : ""}`}
          onClick={() => setActiveView("updates")}
        >
          آخر التحديثات
        </button>
      </div>

      {/* ── Platforms ── */}
      {activeView === "platforms" && (
        <>
          <h3>اختر الخدمة</h3>
          <ServicesList
            services={services}
            platforms={platforms}
            activePlatforms={activePlatforms}
            onSelect={onSelect}
            toggleAll={toggleAll}
          />
          <button className="print" onClick={printPlatformCards}>
            طباعة التقرير
          </button>
        </>
      )}

      {/* ── Reports ── */}
      {activeView === "reports" && (
        <>
          <h3>اختر نوع التقرير</h3>
          <ReportsList
            reports={reports}
            activeReportTab={activeReportTab}
            setActiveReportTab={setActiveReportTab}
          />
          {activeReportTab !== "comreport" && (
            <button className="print" onClick={printReports}>
              طباعة {REPORT_TAB_LABELS[activeReportTab] || "التقارير"}
            </button>
          )}
        </>
      )}

      {/* ── Updates / Timeline ── */}
      {activeView === "updates" && (
        <>
          <h3>آخر التحديثات</h3>
          <p className="empty-service">
            هنا هتلاقي آخر تحديث حصل في أي تقرير أو منصة، مع التاريخ ومكان
            التحديث.
          </p>
          <button className="print" onClick={printUpdates}>
            طباعة آخر التحديثات
          </button>
        </>
      )}
    </div>
  );
};

export default Sidebar;
